import { motion } from "framer-motion";
import { User, Building2, IdCard, Compass, Sparkles, FileCheck2, TrendingUp } from "lucide-react";

const ease = [0.22, 1, 0.36, 1];

const FLOW = [
  { icon: IdCard, label: "Profile" },
  { icon: Compass, label: "Opportunities" },
  { icon: Sparkles, label: "Matching", highlight: true },
  { icon: FileCheck2, label: "Application" },
  { icon: TrendingUp, label: "Progress" },
];

const Party = ({ icon: Icon, label, delay }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, delay, ease }}
    className="flex flex-col items-center gap-2"
  >
    <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-slate-200 bg-white text-ink shadow-[0_8px_20px_rgba(10,37,64,0.06)]">
      <Icon className="h-6 w-6" strokeWidth={1.75} />
    </div>
    <span className="text-xs font-semibold text-slatey">{label}</span>
  </motion.div>
);

export const EcosystemVisual = () => (
  <div className="relative mx-auto aspect-square w-full max-w-[520px]">
    <div className="absolute inset-6 rounded-[40px] bg-gradient-to-b from-cobalt/[0.06] to-transparent" />
    <div className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-cobalt/15 blur-2xl" />
    <div className="absolute -left-8 bottom-10 h-28 w-28 rounded-full bg-cobalt/10 blur-3xl" />

    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, ease }}
      className="animate-float-slow relative flex h-full flex-col justify-center rounded-[28px] border border-slate-200 bg-white/85 backdrop-blur-xl p-7 shadow-[0_30px_80px_rgba(10,37,64,0.14)]"
    >
      {/* Learner  —  hub  —  Provider */}
      <div className="flex items-center justify-between">
        <Party icon={User} label="Learner" delay={0.15} />
        <div className="relative mx-2 flex-1">
          <div className="h-px w-full bg-gradient-to-r from-slate-200 via-cobalt/40 to-slate-200" />
        </div>
        <motion.div
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.3, ease }}
          className="flex h-16 w-16 flex-col items-center justify-center rounded-2xl bg-cobalt text-white shadow-[0_12px_30px_rgba(23,147,90,0.35)]"
        >
          <span className="font-display text-lg font-black leading-none">OD</span>
          <span className="mt-0.5 text-[8px] font-semibold uppercase tracking-[0.1em] opacity-80">Hub</span>
        </motion.div>
        <div className="relative mx-2 flex-1">
          <div className="h-px w-full bg-gradient-to-r from-slate-200 via-cobalt/40 to-slate-200" />
        </div>
        <Party icon={Building2} label="Provider" delay={0.45} />
      </div>

      <p className="mt-5 text-center text-[11px] font-semibold uppercase tracking-[0.18em] text-slatey">
        Connected education ecosystem
      </p>

      {/* Journey flow */}
      <div className="mt-6 rounded-2xl border border-slate-100 bg-slate-50 p-4">
        <div className="flex items-center justify-between">
          {FLOW.map((s, i) => (
            <div key={s.label} className="flex flex-1 items-center">
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.6 + i * 0.12, ease }}
                className="flex flex-col items-center gap-1.5"
              >
                <div className={`relative flex h-10 w-10 items-center justify-center rounded-xl ${s.highlight ? "bg-cobalt text-white animate-pulse-ring" : "bg-white text-cobalt border border-slate-200"}`}>
                  <s.icon className="h-5 w-5" strokeWidth={1.9} />
                </div>
                <span className="text-[9px] font-medium text-slatey text-center leading-tight">{s.label}</span>
              </motion.div>
              {i < FLOW.length - 1 && (
                <div className="mx-1 h-px flex-1 bg-slate-200" />
              )}
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  </div>
);
